export default "__VITE_ASSET__0qvla2bVg1MBHJB3warEDA__"